import { AlertCircle, Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export function InvestigationDetailLoader() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-0 flex-1 items-center justify-center bg-background text-sm text-muted-foreground">
      <Loader2 className="mr-2 size-4 animate-spin" />
      {t('investigations.page.loading')}
    </div>
  )
}

export function InvestigationDetailError({
  backHref,
  onRetry,
}: {
  backHref: string
  onRetry: () => void
}) {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-3 bg-background p-8 text-sm">
      <AlertCircle className="size-6 text-destructive" />
      <p className="text-destructive">{t('investigations.page.loadFailed')}</p>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" onClick={onRetry}>
          {t('investigations.page.loadFailedRetry')}
        </Button>
        <Button asChild variant="ghost" size="sm">
          <Link to={backHref}>{t('investigations.detail.backToList')}</Link>
        </Button>
      </div>
    </div>
  )
}

export function InvestigationDetailNotFound({ backHref }: { backHref: string }) {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-3 bg-background p-8 text-sm">
      <AlertCircle className="size-6 text-muted-foreground" />
      <p className="text-muted-foreground">{t('investigations.detail.notFound')}</p>
      <Button asChild variant="outline" size="sm">
        <Link to={backHref}>{t('investigations.detail.backToList')}</Link>
      </Button>
    </div>
  )
}
